/**
 * The starter dashboard (spec §9.24): what a fresh workspace opens with — bin (wants), list (today),
 * tracking-status, calendar-week.
 * Declared as a bundle (`bundleId: "starter"`) so M8's importer can adopt and update it in place.
 */
import type { LoroDoc } from "loro-crdt";
import { createDashboard, listDashboards, type Dashboard } from "./model";

export const STARTER_BUNDLE_ID = "starter";

export function ensureStarterDashboard(doc: LoroDoc): Dashboard {
  const existing = listDashboards(doc).find(
    (d) => d.id === "starter/home" || (d.bundleId === STARTER_BUNDLE_ID && d.slug === "home"),
  );
  if (existing) return existing;
  return createDashboard(doc, {
    id: "starter/home",
    slug: "home",
    title: "Home",
    titleKey: "dashboards.starterTitle",
    bundleId: STARTER_BUNDLE_ID,
    cols: 12,
    rowHeight: 40,
    widgets: [
      { viewType: "bin", x: 0, y: 0, w: 7, h: 10, config: { limit: 8 }, title: "" },
      { viewType: "tracking-status", x: 7, y: 0, w: 5, h: 5, config: {} },
      { viewType: "list", x: 7, y: 5, w: 5, h: 10, config: { showDoneToday: true, quickAdd: true } },
      { viewType: "calendar-week", x: 0, y: 10, w: 7, h: 9, config: {} },
    ],
  });
}

export const ALL_SLUG = "all";

/**
 * *All workspaces* (ADR 0024), a dashboard preset since UI cleanup U2 (it was a page of its own, `/all`): what is
 * due by today, what wants doing, and the week, from every workspace the person belongs to.
 */
export function ensureAllDashboard(doc: LoroDoc): Dashboard {
  const existing = listDashboards(doc).find((d) => d.id === "starter/all");
  if (existing) return existing;
  return createDashboard(doc, {
    id: "starter/all",
    slug: ALL_SLUG,
    title: "All workspaces",
    titleKey: "all.title",
    bundleId: STARTER_BUNDLE_ID,
    cols: 12,
    rowHeight: 40,
    widgets: [
      {
        viewType: "list",
        x: 0,
        y: 0,
        w: 6,
        h: 10,
        titleKey: "all.due",
        config: {
          source: "all",
          quickAdd: false,
          showDoneToday: false,
          filter: { prop: "due", onOrBefore: { days: 0 } },
        },
      },
      {
        viewType: "bin",
        x: 6,
        y: 0,
        w: 6,
        h: 10,
        titleKey: "all.wants",
        config: { source: "all", for: "anyone" },
      },
      {
        viewType: "calendar-week",
        x: 0,
        y: 10,
        w: 12,
        h: 12,
        titleKey: "all.week",
        config: { source: "all" },
      },
    ],
  });
}
